import styled from 'styled-components';

import { Section, SectionTitle } from '..';
import { Field, useField } from 'formik';
import { AutocompeteInputField, CheckboxField, AutocompeteLoadingInputField } from '../../../fields';
import { api } from '../../../../api';
import { CircularProgress } from '@mui/material';

export const Wix = () => {
  const [field] = useField('campaign.createWixContact');

  const wixCoupons = api.useGetWixContactsLabelsQuery(undefined, { refetchOnMountOrArgChange: true });

  return (
    <DisplaySettingsWrapper>
      <Section elevation={0}>
        <SectionTitle>Wix integration</SectionTitle>

        <Row noMargin>
          <Field
            name="campaign.createWixContact"
            component={CheckboxField}
            label="Create contact"
            className="form-field"
          />
        </Row>

        {field.value && (
          <CreateContactSettings>
            <Row noMargin>
              {wixCoupons.isSuccess ? (
                <Field
                  name="campaign.wixContactLabelIds"
                  component={wixCoupons.isLoading ? AutocompeteLoadingInputField : AutocompeteInputField}
                  label="Contact labels"
                  options={wixCoupons.data || []}
                  multiple
                />
              ) : (
                <CircularProgress size={30} />
              )}
            </Row>

            <Row noMargin>
              <Field
                name="campaign.createWixInbox"
                component={CheckboxField}
                label="Create inbox"
                className="form-field"
              />
            </Row>

            <Row noMargin>
              <Field
                name="campaign.subscribeEmail"
                component={CheckboxField}
                label="Create email subscription"
                className="form-field"
              />
            </Row>
          </CreateContactSettings>
        )}
      </Section>
    </DisplaySettingsWrapper>
  );
};

const DisplaySettingsWrapper = styled.div``;

const Row = styled.div<{ noMargin?: boolean }>`
  display: flex;

  ${(p) => !p.noMargin && `margin-bottom: 24px;`}

  :last-of-type {
    ${(p) => !p.noMargin && `margin-bottom: 12px;`}
  }
`;

const CreateContactSettings = styled.div`
  margin-left: 16px;
`;
